/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CittadinoMensaStudenteDTO } from '../model/cittadino-mensa-studente-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    CittadinoStudentiMensaServiceInterface
} from './cittadino-studenti-mensa.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CittadinoStudentiMensaService extends BaseService implements CittadinoStudentiMensaServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Lista cross-servizio degli studenti mensa del cittadino.
     * Audience: CITTADINO. Tutti gli studenti del caller su tutti i servizi mensa attivi (data_inizio &lt;&#x3D; oggi e data_fine assente o &gt;&#x3D; oggi) la cui Pratica origine è accettata, ciascuno col blocco servizio del comune di afferenza (servizio.id &#x3D; header Gestione-Mense-Servizio-Id degli step successivi) + servizio.tipo_pagamento (prepagato vs scadenza mensile). Ogni riga porta inoltre, quando disponibili: il blocco \&#39;portafogli\&#39; (residuo, costo_pasto, saldo_iniziale, pasti_usufruiti) e il blocco \&#39;pagamenti\&#39; (is_presente_ricarica_da_pagare, giorni_residui_sospensione_servizio). Semantica blocco-omesso: \&#39;portafogli\&#39; omesso &#x3D; studente senza portafogli; \&#39;pagamenti\&#39; omesso &#x3D; nessuna ricarica in attesa di pagamento (&#x3D; nessun pagamento dovuto). \&#39;giorni_residui_sospensione_servizio\&#39; è presente solo oltre la soglia promemoria e mai negativo. Lo stesso figlio su più servizi produce una riga per servizio. Lista non paginata, non ordinata server-side (ordinamento lato client).
     * @endpoint get /api/v1/cittadino/servizi/mensa-studenti
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listMensaStudentiCittadino(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CittadinoMensaStudenteDTO>>;
    public listMensaStudentiCittadino(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CittadinoMensaStudenteDTO>>>;
    public listMensaStudentiCittadino(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CittadinoMensaStudenteDTO>>>;
    public listMensaStudentiCittadino(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa-studenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CittadinoMensaStudenteDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
